import { geniFetch } from "../geniBackend";

type WbResolvedCategoryCandidate = {
  id: number;
  name: string;
  breadcrumb: string;
  query: string;
  score: number;
};

type ResolveWbCategoryResponse = {
  best: WbResolvedCategoryCandidate | null;
  alternatives: WbResolvedCategoryCandidate[];
  status: "ok" | "uncertain";
  reason: "low_score" | "close_scores" | null;
};

/**
 * GC-23: `description` опциональный. Бэк использует его и в семантическом поиске (embedding),
 * и в AI tie-break, чтобы не путать общие названия (напр. «100 таблеток») с похожими, но
 * другими по сути товарами. Внутри обрезается до ~300/500 символов.
 */
export const resolveWbCategory = async (
  title: string,
  description?: string,
): Promise<ResolveWbCategoryResponse> => {
  const trimmedDescription = description?.trim();
  return await geniFetch<ResolveWbCategoryResponse>("/wb-categories/resolve", {
    method: "POST",
    body: JSON.stringify({
      title,
      ...(trimmedDescription ? { description: trimmedDescription } : {}),
    }),
  });
};
